import { RT_API_USAGE } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  configReady: null,
  usageEntries: [],
  usageMasks: {
    ytdMatched: [],
    mtdMatched: [],
    btdMatched: [],
    tdyMatched: [],
    '7dMatched': [],
    '30dMatched': [],
    '1yMatched': [],
    '3cMatched': [],
    '6cMatched': [],
    '12cMatched': [],
    ytdUnmatched: [],
    mtdUnmatched: [],
    btdUnmatched: [],
    tdyUnmatched: [],
    '7dUnmatched': [],
    '30dUnmatched': [],
    '1yUnmatched': [],
    '3cUnmatched': [],
    '6cUnmatched': [],
    '12cUnmatched': [],
    ytdTotal: [],
    mtdTotal: [],
    btdTotal: [],
    tdyTotal: [],
    '7dTotal': [],
    '30dTotal': [],
    '1yTotal': [],
    '3cTotal': [],
    '6cTotal': [],
    '12cTotal': [],
  },
  rttHist: [],
  config: null,
  configList: [],
  filter: CONSTANTS.REAL_TIME_API.USAGE.FILTER.LAST_7_DAYS,
  fetchConfigUnifiedError: null,
  fetchConfigUnifiedStatus: null,
  fetchRttEntriesError: null,
  fetchRttEntriesStatus: null,
  fetchUsageEntriesError: null,
  fetchUsageEntriesStatus: null,
  generateUsageStatsError: null,
  generateUsageStatsStatus: null,
  mtdCount: null,
  tdyCount: null,
  ytdCount: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RT_API_USAGE.RESET:
      return INITIAL_STATE;
    case RT_API_USAGE.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case RT_API_USAGE.UPDATE_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case RT_API_USAGE.FETCH_CONFIG:
    case RT_API_USAGE.FETCH_CONFIG_LIST:
      return {
        ...state,
        fetchConfigUnifiedStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST_FAILURE:
      return {
        ...state,
        fetchConfigUnifiedError: action.payload,
        fetchConfigUnifiedStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST_SUCCEEDED:
      return {
        ...state,
        fetchConfigUnifiedStatus: CONSTANTS.API.SUCCEEDED,
        configList: action.payload,
      };
    case RT_API_USAGE.FETCH_CONFIG_LIST_SUCCEEDED_EMPTY:
      return {
        ...state,
        fetchConfigUnifiedStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.FETCH_CONFIG_FAILURE:
      return {
        ...state,
        fetchConfigUnifiedStatus: CONSTANTS.API.FAILED,
        fetchConfigUnifiedError: action.payload,
      };
    case RT_API_USAGE.FETCH_CONFIG_SUCCEEDED:
      return {
        ...state,
        config: action.payload,
        fetchConfigUnifiedStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.FETCH_USAGE_ENTRIES:
      return {
        ...state,
        fetchUsageEntriesStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_USAGE_ENTRIES_FAILED:
      return {
        ...state,
        fetchUsageEntriesError: action.payload,
        fetchUsageEntriesStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_USAGE_ENTRIES_SUCCEEDED:
      return {
        ...state,
        ...action.payload,
        fetchUsageEntriesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case RT_API_USAGE.FETCH_RTT_ENTRIES:
      return {
        ...state,
        fetchRttEntriesStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.FETCH_RTT_ENTRIES_FAILED:
      return {
        ...state,
        fetchRttEntriesError: action.payload,
        fetchRttEntriesStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.FETCH_RTT_ENTRIES_SUCCEEDED:
      return {
        ...state,
        ...action.payload,
        fetchRttEntriesStatus: CONSTANTS.API.SUCCEEDED,
      };
    /*
    case RT_API_USAGE.FETCH_RTT_ENTRIES_SUCCEEDED_EMPTY:
      return {
        ...state,
        fetchRttEntriesStatus: CONSTANTS.API.SUCCEEDED,
      };
*/
    case RT_API_USAGE.GENERATE_USAGE_STATS:
      return {
        ...state,
        generateUsageStatsStatus: CONSTANTS.API.STARTED,
      };
    case RT_API_USAGE.GENERATE_USAGE_STATS_FAILED:
      return {
        ...state,
        generateUsageStatsError: action.payload,
        generateUsageStatsStatus: CONSTANTS.API.FAILED,
      };
    case RT_API_USAGE.GENERATE_USAGE_STATS_SUCCEEDED:
      return {
        ...state,
        ...action.payload,
        generateUsageStatsStatus: CONSTANTS.API.SUCCEEDED,
      };
    default:
      return state;
  }
};
